// extracted by mini-css-extract-plugin
module.exports =  {"container":"a10a3f92e9--container--SBnlZ","wrapper":"a10a3f92e9--wrapper--g5gxY","title":"a10a3f92e9--title--knJ4f","image":"a10a3f92e9--image--jj_dG"};